import VerifiedBadge from "../../../../components/VerifiedBadge";
import { JobApplication } from "../model/JobModel";

interface ApplicationCardProps {
  applications: JobApplication;
  onView: () => void;
  onContact?: () => void;
}

export function ApplicationListCard({
  applications,
  onView,
  onContact,
}: ApplicationCardProps) {
  const isVerified =
    applications.candidate.is_identity_verified === true ||
    applications.candidate.is_id_verified === true;

  const getStatusColor = (status: string) => {
    switch (status) {
      case "New":
        return "bg-blue-100 text-blue-700";
      case "Reviewing":
        return "bg-yellow-100 text-yellow-700";
      case "Interview Scheduled":
        return "bg-purple-100 text-purple-700";
      case "Offered":
        return "bg-green-100 text-green-700";
      case "Rejected":
        return "bg-red-100 text-red-700";
      case "Hired":
        return "bg-emerald-100 text-emerald-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    // <div className="bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow duration-200">
    //   <div className="p-6">
    //     {/* Header */}
    //     <div className="flex items-start justify-between mb-4">
    //       <div className="flex items-center space-x-3">
    //         <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center">
    //           <span className="text-lg font-semibold text-indigo-600">
    //             {applications.candidate_name?.[0]}
    //             {applications.candidate_name?.[1]}
    //           </span>
    //         </div>
    //         <div>
    //           <h3 className="text-lg font-semibold text-gray-900">
    //             {applications.candidate_name}
    //           </h3>
    //           {/* {applications.job_title && applications.c && (
    //             <p className="text-sm text-gray-600">
    //               {applications.job_title} at {applications.current_company}
    //             </p>
    //           )} */}
    //         </div>
    //       </div>

    //       {/* {candidate.ai_match_score && (
    //         <Tooltip
    //           content="How well this candidate matches your job requirements"
    //           position="left"
    //         >
    //           <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-help">
    //             {Math.round(candidate.ai_match_score * 100)}% Match
    //           </span>
    //         </Tooltip>
    //       )} */}
    //     </div>

    //     {/* Key Information */}
    //     <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-4 text-sm">
    //       {applications.years_of_experience && (
    //         <div>
    //           <span className="text-gray-500">Experience</span>
    //           <p className="font-medium text-gray-900">
    //             {applications.years_of_experience} years
    //           </p>
    //         </div>
    //       )}
    //     </div>

    //     {/* Skills */}
    //     {/* {topSkills.length > 0 && (
    //       <div className="mb-4">
    //         <h4 className="text-sm font-medium text-gray-700 mb-2">Skills</h4>
    //         <div className="flex flex-wrap gap-2">
    //           {topSkills.map((skill, index) => (
    //             <span
    //               key={index}
    //               className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800"
    //             >
    //               {skill.skill_name}
    //               {skill.proficiency_level && (
    //                 <span className="ml-1 text-blue-600">
    //                   ({skill.proficiency_level})
    //                 </span>
    //               )}
    //             </span>
    //           ))}
    //           {candidate.skills && candidate.skills.length > 5 && (
    //             <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
    //               +{candidate.skills.length - 5} more
    //             </span>
    //           )}
    //         </div>
    //       </div>
    //     )} */}

    //     {/* Actions */}
    //     <div
    //       className={`flex mt-2 ${
    //         applications.contact_unlocked ? "space-x-2" : "justify-end"
    //       }`}
    //     >
    //       {applications.contact_unlocked && (
    //         <button className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-md text-sm font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
    //           Contact
    //         </button>
    //       )}

    //       <button
    //         onClick={onView}
    //         className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    //         //       className={`text-xs bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700
    //         //   ${applications.contact_unlocked ? "flex-1" : ""}
    //         // `}
    //       >
    //         View
    //       </button>
    //     </div>
    //   </div>
    // </div>
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-200 h-full flex flex-col">
      {/* Header */}
      <div className="bg-white rounded-lg p-4 relative">
        <div className="flex justify-between items-start mb-3">
          <div className="min-w-0">
            {/* <p className="text-xs text-gray-500">Current Job Title</p> */}
            <h2 className="text-sm font-semibold text-gray-900 truncate">
              {applications.candidate.current_job_title || "No Title"}
            </h2>
            {isVerified && (
              <span className="mt-1 inline-flex">
                <VerifiedBadge />
              </span>
            )}
          </div>

          <span
            className={`shrink-0 px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
              applications.status,
            )}`}
          >
            {applications.status.replace("_", " ")}
          </span>
        </div>

        <div className="space-y-1">
          <div className="flex gap-1 text-xs">
            <span className="text-gray-500">Experience:</span>
            <span className="text-gray-800 font-medium">
              {applications.candidate.years_of_experience ?? 0} years
            </span>
          </div>
        </div>

        {/* Footer */}
        <div
          className={`flex mt-2 ${
            applications.contact_unlocked ? "space-x-2" : "justify-end"
          }`}
        >
          {applications.contact_unlocked && (
            <button
              onClick={onContact}
              className="flex-1 text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded hover:bg-gray-200"
            >
              Contact
            </button>
          )}

          <button
            onClick={onView}
            className={`text-xs bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700
      ${applications.contact_unlocked ? "flex-1" : ""}
    `}
          >
            View
          </button>
        </div>
        {/* <div className="mt-4 flex justify-start">
          <button
            onClick={onView}
            className="text-xs text-blue-600 hover:underline"
          >
            View Profile →
          </button>
        </div> */}
      </div>
    </div>
  );
}
